import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-landing-popup',
  templateUrl: './landing-popup.component.html',
  styleUrls: ['./landing-popup.component.scss']
})
export class LandingPopupComponent implements OnInit {

  bdqQuote = false;
  constructor(public dialogRef: MatDialogRef<LandingPopupComponent>) { }

  ngOnInit(): void {
    const sourceIndicator = sessionStorage.getItem('sourceIndicator');
    if(['BW', 'BI', 'BDQI'].includes(sourceIndicator)) {
      this.bdqQuote = true;
    }
  }


}
